import React,{useState,useEffect} from "react";
import { TextField,Button,Typography,Paper} from "@material-ui/core";
import useStyles from './style.js';
import {createPost,updatePost} from'../../Actions/posts';
import FileBase from 'react-file-base64';
import {useDispatch,useSelector} from 'react-redux';
import { useHistory } from "react-router-dom";
const Form = ({currentId,setCurrentId})=>{
    const [postData,setPostData] = useState({title:'', message:'', tags:[],selectedFile:''})
    const classes = useStyles();
    const history = useHistory();
    const post = useSelector((state)=>currentId?state.posts.posts.find((pst)=>pst._id === currentId):null);
    const dispatch = useDispatch();
    const user = JSON.parse(localStorage.getItem('profile'));
    // console.log(user);
    useEffect(()=>{
        if(post)
            setPostData(post);
    },[post]);

    const clear = ()=>{
        setCurrentId(0);
        
        setPostData({title:'', message:'', tags:[],selectedFile:''});
        
    };

    const handleSubmit= async (e) => {
        e.preventDefault();
        if(currentId !== 0)
        {
            dispatch(updatePost(currentId,{...postData,name:user?.result.name}));
            clear();
        }
        else
        {
            dispatch(createPost({...postData,name:user?.result.name},history));
            clear();
        }
        
    };
    if(!user?.result.name)
    {
        return(
            <Paper className={classes.paper}>
                <Typography variant="h5" align="center">
                Please Sign In to create your own memories and like other's memories.
                </Typography>
            </Paper>
        )
    }

    return(
        <Paper className={classes.paper}>
            <form autoComplete="off" noValidate className={`${classes.root} ${classes.form}`} onSubmit={handleSubmit}>
                <Typography variant="h6">{currentId? 'Editing   ':'Creating '}a Memory</Typography>
                
                <TextField name="title" variant="outlined" label="Title" fullWidth value={postData.title} 
                onChange={(e)=>setPostData({...postData,title:e.target.value})}
                //will be spreading postData otherwise it will be over writing the same property in different textfields
                />
                <TextField name="message" variant="outlined" label="Message" fullWidth value={postData.message} 
                onChange={(e)=>setPostData({...postData,message:e.target.value})}
                //will be spreading postData otherwise it will be over writing the same property in different textfields
                />
                <TextField name="tags" variant="outlined" label="Tags" fullWidth value={postData.tags} 
                onChange={(e)=>setPostData({...postData,tags:e.target.value.split(',')})}
                //will be spreading postData otherwise it will be over writing the same property in different textfields
                />
                <div className={classes.fileInput}><FileBase multiple={false} onDone={({ base64 }) => setPostData({ ...postData, selectedFile: base64 })} /></div>
                <Button className={classes.buttonSubmit} variant="contained" color="primary" size="large" type="submit" fullWidth>
                    Submit
                </Button>
                <Button variant="contained" color="secondary" size="small" onClick={clear} fullWidth>
                    Clear
                </Button>

            </form>
        </Paper>
    )
};

export default Form;
